import {
  Avatar,
  AvatarFallback,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/index';

import type { Appointment } from '../../../../react-query/useAppointments';
import { useFormatAppointmentDate } from '../../helpers';

export const AppointmentInfo = ({
  appointment,
  hideProviderAvatar = false,
  isDrawer,
  isIncludeOperatory = false,
}: {
  appointment: Appointment;
  hideProviderAvatar?: boolean;
  isDrawer?: boolean;
  isIncludeOperatory?: boolean;
}) => {
  const provider = appointment.appointment.provider;
  const operatory = appointment.appointment.operatory;
  const startDate = appointment.appointment.start;

  const formattedDate = useFormatAppointmentDate(startDate);

  const renderAvatar = () => {
    if (!provider?.firstName || !provider?.lastName) {
      return null;
    }
    const initials = `${provider.firstName[0]}${provider.lastName[0]}`;

    return (
      <Avatar className="vai-bg-slate-50 vai-p-0 vai-m-0 vai-border-none vai-text-white vai-font-bold vai-text-sm vai-h-7 vai-w-7 ">
        <AvatarFallback className="vai-bg-text-accent vai-p-0 vai-m-0 vai-border-none vai-text-white vai-font-bold vai-text-sm vai-h-7 vai-w-7">
          {initials}
        </AvatarFallback>
      </Avatar>
    );
  };

  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        {!isDrawer && (
          <div className="vai-flex vai-flex-row vai-flex-wrap vai-gap-2 vai-items-center">
            {provider && provider.firstName && provider.lastName && (
              <Tooltip delayDuration={100}>
                {!hideProviderAvatar && (
                  <TooltipTrigger className="vai-bg-slate-50 vai-p-0 vai-m-0 vai-border-none">
                    {renderAvatar()}
                  </TooltipTrigger>
                )}
                <TooltipContent>
                  {`${provider.firstName} ${provider.lastName}`}
                </TooltipContent>
              </Tooltip>
            )}
            {isIncludeOperatory && operatory?.name && (
              <span
                className="vai-text-lg vai-font-bold"
                data-text={operatory.name}
              >
                {operatory.name}
              </span>
            )}
            {startDate && (
              <div className="flex items-center">
                <span className="vai-text-md">{formattedDate}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
